import React, { Component } from 'react';
import {NavLink, Link} from "react-router-dom";
import logodashheader  from '../Assets/logo-dash-header.png';
import FeedBackImg from '../Assets/ratings-review.png';
import Footer from "../Components/footer";
import  Header  from "../Components/header";
import SideBar from "../Components/sidebar";
import Button from "../Components/button";
import DataTable from "../Components/datatablewallet";
import { DateTime, RedirectNotLogin, getSession, UpdateState, getState, handleSubmit, BreedForm, AlertMessage, AlertMessageOut, serializeArray } from "../Components/function";

class Wallet extends Component{

  constructor(props){
    super(props);
    
    this.state = {
      userID : '',
      scriptID: '',
      file: '',
      message: '',
    }
    }
    
    componentDidMount(){
      RedirectNotLogin();
    }

    componentDidUpdate() {
      RedirectNotLogin();
    }
 
  render(){
    return (
        <div className="App AppWrap">
    
    <Header self={this}/>
    <SideBar self={this}/>
    

    <div className="App iBG dash-dash">
    <div className="containers">
   
  <div className="card-lt-wrap" hidden>
    <div className="card-lt">
  <h1>Review</h1>
  </div>
  </div>

  <div className="card-lt-wrap">
    <div className="card-lt">
     
     {AlertMessageOut(this)}

     <DataTable
     route="wallet"
     badge={['', '', '', '', '']}
     thclassX={['nowrap', 'nowrap', '', 'nowrap', 'nowrap']}
     th={
        ['Amount', 'Type', 'Summary', 'TxID', 'Tx Date']
     }
     td={
        ['amount', 'type', 'summary', 'txid', 'date']
    }
     cmd="wallet"
     self={this}
     />

    
     </div>

        <Footer classX="dash-footer"/>

    </div>
    
    </div>

    </div>

    </div>
    );
}

}

export default Wallet;